import React, {Fragment, useEffect, useState, useMemo} from 'react';
import {connect} from 'react-redux';
import classnames from 'classnames';
import {injectIntl} from '@s7ui-kit/s7ui-kit';
import isEmpty from 'lodash/isEmpty';

import { Section } from '../../main/Section';
import pushGA from '../../../services/utils/pushGA';
import requestUtil from '../../../services/services/requestUtil';
import Card from '../../../components/common/Card/Card';
import HorizontalScroll from '../../common/HorizontalScroll/HorizontalScroll';

import {
    analyticsMainPageBlockLoaded,
    analyticsMainPageBlockShown,
    analyticsMainPageBlockClick
} from '../../../services/analytics/analyticsMainpage';

import '../new-mainpage/blog-block.scss';

const mapStateToProps = ({App, User}) => ({App, User});

const BlogBlock = (props) => {
    const {App: {lang, deviceWidth}} = props;
    const { words, getMessage } = props;

    const [ gotBlogs, setGotBlogs ] = useState(false);
    const [ blogs, setBlogs ] = useState([]);

    useEffect(() => {
        getMessage(words, 'com.s7.main.page.all.media');

        const limit = 3;

        const searchParams = new URLSearchParams('');
        searchParams.append('lang', lang);
        searchParams.append('limit', limit);

        requestUtil(`/ext/s7media/api/v2/blogs/latest?${searchParams}`)
            .then(response => {
                if (!response || response.length === 0 ) {
                    setGotBlogs(false);
                    return;
                }

                setBlogs(response);
                setGotBlogs(true);
            }).catch((e) => {
                setGotBlogs(false);
                throw new Error(e);
            });
    }, []);

    useEffect(()=> {
        if(!gotBlogs){
            return;
        }
        analyticsMainPageBlockLoaded({
            step: 'blog',
            items: ecomParamsForGA
        });
    }, [gotBlogs]);

    const inView = () => {
        setTimeout(()=> {
            analyticsMainPageBlockShown({
                step: 'blog',
                items: ecomParamsForGA,
                ux: deviceWidth < 768 ? 'carousel': 'auto_open'
            })
        }, 2000);
    };

    const onClickArticle = index => {
        analyticsMainPageBlockClick({
            step: 'blog',
            items: [ecomParamsForGA[index]]
        })
    };

    const onClickShowMore = () => {
        analyticsMainPageBlockClick({
            step: 'blog',
            items: [{
                item_id: 'all',
                item_name: 'blog',
                affiliation: 'content',
                index: undefined,
                location_id: 's7_main'
            }]
        })
    };

    const ecomParamsForGA = useMemo(() => {
        return blogs.map((blog, index) => {
            return {
                item_id: blog.code,
                item_name: 'blog',
                affiliation: 'content',
                index: index + 1,
                location_id: 's7_main'
            }
        })
    }, [ blogs ]);

    const sliderArray = () => {
        let arr = [];

        blogs.map((item, index) => {
            arr.push(<Card
                key={`blogs-${item.id}`}
                item={ setCommonItem(item) }
                gaName='blog'
                shadowMode={true}
                offersMode={true}
                classes={{mobile320: true}}
                itemClass={'blogs-block-holder-item'}
                isMedia={true}
                onClick={() => onClickArticle(index)}
            />)
        });

        return arr;
    };

    const renderBlogsItems = () => {
        const { App: { deviceWidth } } = props;
        const slides = sliderArray();

        if ( !isEmpty(blogs) && Array.isArray(blogs.items) && !isEmpty(blogs.items) ) {
            return;
        }

        return deviceWidth > 767 ? <Fragment>
                {
                    deviceWidth > 1024 ? blogs.map((item, index) => (
                        <div key={`blogs-${item.id}-container`}
                             className={'blogs-block-item'}>
                            <Card
                                key={`blogs-${item.id}`}
                                item={ setCommonItem(item) }
                                gaName='blog'
                                offersMode={true}
                                itemClass={'blogs-block-holder-item'}
                                isMedia={true}
                                onClick={() => onClickArticle(index)}
                            />
                        </div>
                    ))
                    :
                    blogs.slice(0, 2).map((item, index) => (
                        <div key={`blogs-${item.id}-container`}
                             className={'blogs-block-item'}>
                            <Card
                                key={`blogs-${item.id}`}
                                item={ setCommonItem(item) }
                                gaName='blog'
                                offersMode={true}
                                itemClass={'blogs-block-holder-item'}
                                isMedia={true}
                                onClick={()=>onClickArticle(index)}
                            />
                        </div>
                    ))
                }
            </Fragment>
            :
            <HorizontalScroll>
                {slides.map((item, index) => (
                        <div
                            className={classnames({
                                'blogs-block-mobile-item': true,
                                'blogs-block-mobile-item-wide': index == slides.length -1
                            })}
                        >
                            { item }
                        </div>
                    ))}
            </HorizontalScroll>
    };

    const setCommonItem = item => {
        return {
            title: item.title,
            subtitle: item.subtitle,
            src: item.offerThumbnail?.url  || '',
            identifier: item.id,
            code: `/${lang}/blog/${item.code}`
        };
    };
    
    if(!gotBlogs){
        return null;
    }

    return (<Section
        title={getMessage(words, 'com.s7.main.page.media.all')}
        className={'blogs-block'}
        onClick={()=>{
            onClickShowMore();
            pushGA(
                'portal_main_s7media_section',
                'goto_s7media',
                'type:all_articles',
                {
                    eventValue: 0,
                    eventUX: 'undefined',
                    eventInteraction: 0
                });
        }}
        link={`${process.env.REACT_APP_MEDIA}/${lang}/blog/`}
        text={getMessage(words, 'com.s7.main.page.section.blog.show.all')}
        inView={inView}
    >
        <div className={'blogs-block-holder'}>
            { renderBlogsItems() }
        </div>
    </Section>);

};

export default injectIntl(connect(mapStateToProps)(React.memo(BlogBlock)));